import React, { useState, useCallback, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { IoHeartOutline, IoHeartSharp, IoCloseSharp } from "react-icons/io5";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { useSession } from "../../ApiCalls/useSession";
import { BASE_URL, USER_URL } from "../../constant/api";
import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";

function SearchResult({ searchResult }) {

    useSession()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const openModal = useCallback((product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    }, []);

    useEffect(() => {
        const getWishlist = async () => {
            

            try {
                const response = await USER_URL.get(`/products/wishlist/`, {
                    
                });
                setWishlist(response.data.items.map((item) => item.product_id));
                // console.log(response)
            } catch (error) {
                console.error("Error fetching wishlist:", error);
            }
        };

        getWishlist();
    }, []);

    // Toggle Wishlist
    const toggleWishlist = async (product_id) => {
        try {
            const isWishlisted = wishlist.includes(product_id);
            

            const res = await USER_URL.post(
                `/products/wishlist/`,
                { product_id },
               
            );

            // console.log(res);

            setWishlist((prev) =>
                isWishlisted
                    ? prev.filter((id) => id !== product_id)
                    : [...prev, product_id]
            );
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };

    const handleDeleteWishlistItem = async (productId) => {
        

        try {
            const response = await USER_URL.delete(`/products/wishlist/${productId}/`, {
                // data: { product_id: productId },
                
            });

            if (response.data.Status === "1") {
                // Assuming `wishlist` is a state variable
                setWishlist((prev) => prev.filter((id) => id !== productId));
                console.log("Item deleted successfully:", response.data);
            } else {
                console.error("Unexpected response:", response.data);
            }
        } catch (error) {
            console.error(`Error deleting item ${productId}:`, error);
        }
    };



    // Function to render the stars
    const totalStars = 5;
    const renderStars = (rating) => {
        const filledStars = Math.floor(rating); // Number of full stars
        const hasHalfStar = rating % 1 >= 0.5; // For half stars
        const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0); // Empty stars

        return (
            <div className="flex justify-center items-center">
                {/* Render Filled Stars */}
                {[...Array(filledStars)].map((_, index) => (
                    <FaStar key={`filled-${index}`} className="text-yellow-500" />
                ))}

                {/* Render Half Star */}
                {hasHalfStar && <FaStarHalfAlt key="half-star" className="text-yellow-500" />}

                {/* Render Empty Stars */}
                {[...Array(emptyStars)].map((_, index) => (
                    <FaRegStar key={`empty-${index}`} className="text-gray-400" />
                ))}
            </div>
        );
    };
    return (
        <div>
            {searchResult.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-stretch">
                    {searchResult.map((product) => (
                        <div
                            key={product.id}
                            className="rounded-lg p-2 hover:scale-105 transition-transform ease-in-out duration-300"
                        >

                            <div className="flex flex-col justify-between items-stretch p-2  bg-slate-100  rounded-xl">
                                <div className="flex justify-between items-center text-xs md:text-sm text-brand-light-gray ">
                                    {(product.offer_percent || product.offer_percent === null) && (
                                        <span className="">
                                            {product.offer_percent ? <span className="bg-red-600 rounded-lg p-1 px-2">{product.offer_percent}%</span> : <span className="bg-transparent"></span>}
                                        </span>
                                    )}
                                    <span
                                        className="text-red-700 text-2xl cursor-pointer"
                                        onClick={() =>
                                            wishlist.includes(product.id)
                                                ? handleDeleteWishlistItem(product.id) // Call delete function if the product is in the wishlist
                                                : toggleWishlist(product.id) // Call toggle function to add the product to the wishlist
                                        }
                                    >
                                        {wishlist.includes(product.id) ? (

                                            <IoHeartSharp /> // Filled heart for items in the wishlist
                                        ) : (
                                            <IoHeartOutline /> // Outline heart for items not in the wishlist
                                        )}
                                    </span>

                                </div>
                                <Link to={`/product-details/${product.id}`} className="flex justify-center">
                                    <img
                                        src={
                                            product.product_images?.[0]?.image
                                                ? product.product_images[0].image.startsWith(BASE_URL)
                                                    ? product.product_images[0].image
                                                    : `${BASE_URL}${product.product_images[0].image}`
                                                : "/images/default-product.png"
                                        }
                                        alt={product.name || "Product"}
                                        className="mb-4 h-44 w-44 md:h-52 md:w-52 object-contain p-1 md:p-5"
                                    />
                                </Link>
                            </div>

                            <Link to={`/product-details/${product.id}`}>
                                <h2 className="my-2 text-sm md:text-lg font-bold hover:text-green-500">
                                    {product.name} ({product.min_order_quantity} kg)
                                </h2>
                            </Link>
                            <p className="text-xs md:text-sm text-gray-600 line-clamp-1">{product.description || "No description available"}</p>
                            <div className="mt-2 gap-1 flex flex-col md:flex-row items-start md:items-center space-x-1">
                                {renderStars(product.product_rating)}
                                <p className="ml-2 text-xs md:text-sm text-gray-500">
                                    {product.product_rating} ({product.product_review_count} Reviews)
                                </p>
                            </div>

                            <p className="text-gray-500 my-2">
                                <span className="font-bold text-sm md:text-base text-black">{product.currency_symbol}{product.price}</span>
                                <span className="ml-2 text-xs md:text-sm line-through">
                                    {product.currency_symbol}{product.actual_price}
                                </span>
                                
                            </p>
                            <span
                                className="rounded-md bg-brand-primary text-xs md:text-sm py-1 px-2 text-white cursor-pointer"
                                onClick={() => openModal(product)}
                            >
                                ADD
                            </span>
                           
                        </div>

                    ))}
                </div>
            ) : (
                <p>No products found</p>
            )}
            <AddToCartModel
                selectedProduct={selectedProduct}
                isModalOpen={isModalOpen}
                closeModal={closeModal}
            />
        </div>
    );
}

export default SearchResult;
